// removed by extract-text-webpack-plugin
module.exports = {"container":"_32CJT_5CWkk9qsJUffpE3Z","burger":"_3DvgBw2tFzVwim4P5imZfS","burgerIcon":"_33EheWNNGQO_2L3f1iNgin","searchIcon":"_2-bepE9rZvEvNu6gYj0vmM","label":"_7KuevynWnMm2CTkhs5f40","search":"_1TNkxEfGLQHIiHATR3TSX2"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/Main/style/Header.pcss
// module id = 856
// module chunks = 0